import { ClientOnly } from "@tanstack/react-router";
import { Suspense, lazy } from "react";

import FallbackBackground from "@/components/FallbackBackground";
import Footer from "@/components/Footer";
import PurchaseFinalCTA from "@/components/PurchaseFinalCTA";

import AboutFlowstep from "../components/AboutFlowstep";
import AboutHero from "../components/AboutHero";
import BackedBy from "../components/BackedBy";
import FinalCTAMobile from "../components/FinalCTAMobile";
import Header from "../components/Header";
import LifeAtFlowstep from "../components/LifeAtFlowstep";
import TeamCarousel from "../components/TeamCarousel";
import VideoTextSection from "../components/VideoTextSection";

// Same degradation strategy as Pricing: the static gradient below always
// paints, so a purged chunk degrades to nothing instead of crashing the route.
const ScrollReactiveBackground = lazy(() =>
  import("../components/ScrollReactiveBackground").catch(() => ({
    default: () => <></>,
  })),
);

export default function About() {
  return (
    <div className="relative min-h-screen">
      {/* Static gradient — paints immediately on SSR, then the WebGL canvas
          layers on top once its chunk has loaded. */}
      <FallbackBackground variant="dark" />

      <ClientOnly>
        <Suspense fallback={null}>
          <ScrollReactiveBackground variant="dark" />
        </Suspense>
      </ClientOnly>

      {/* Content with relative positioning to appear above background */}
      <div className="dark text-foreground relative z-10 pt-20 pb-16 lg:pb-0">
        <Header />
        <AboutHero />
        <AboutFlowstep />
        <TeamCarousel />
        <BackedBy />
        <VideoTextSection />
        <LifeAtFlowstep />
        <PurchaseFinalCTA />
        <Footer />
      </div>

      <FinalCTAMobile />
    </div>
  );
}
